import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
  Inject,
  SimpleChanges,
  ViewEncapsulation,
  AfterViewInit,
} from '@angular/core';
import { RxListPhotoItemComponent } from '../rx-list-photo-item';
import { Bundle, Pair, PairGif, Roles } from '@nrwl/rx-models';
import { SelectionManagerService, PAIR_SELECTION } from '@nrwl/rx-service-selection-manager';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RxIconComponent } from '../../rx-icon/rx-icon.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RxRoleGuardDirective } from '@org/rx-directives';

@Component({
  selector: 'rx-list-photo-pair-item',
  templateUrl: './rx-list-photo-pair-item.component.html',
  styleUrls: ['./rx-list-photo-pair-item.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RxIconComponent,
    MatMenuModule,
    MatCheckboxModule,
    RxRoleGuardDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RxListPhotoPairItemComponent extends RxListPhotoItemComponent implements OnInit {
  @Input()
  public useAsContainerOnly = false;

  @Input()
  public imageFirst: string;

  @Input()
  public imageSecond: string;

  @Input()
  public showCheckbox = false;

  @Input()
  public rejectedRoles: Roles[] = [];

  public proportionalHeight: number;
  private resizeObserver: ResizeObserver;

  @HostListener('window:resize', ['$event.target'])
  public onResize() {
    this.recalculateHeight();
  }

  constructor(
    private _changeDetection: ChangeDetectorRef,
    @Inject(PAIR_SELECTION)
    private _pairManageService: SelectionManagerService<Pair | PairGif | Bundle>,
    private _el: ElementRef,
  ) {
    super(_changeDetection);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.resizeObserver?.disconnect();
  }

  public override get image() {
    return `url(${this.imageFirst}), url(${this.imageSecond})`;
  }

  public override ngOnInit() {
    this._pairManageService.deselectAll_$.subscribe((res) => this._changeDetection.markForCheck());
  }

  public ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(() => {
      this.recalculateHeight();
      this._changeDetection.markForCheck();
    });
    this.resizeObserver.observe(this._el.nativeElement);
  }

  // public ngOnDestroy() {
  //     this.resizeObserver?.disconnect();
  // }

  public recalculateHeight() {
    this.proportionalHeight = this._el.nativeElement.getBoundingClientRect().width / 1.5;
  }

  imgErrorHandler(event) {
    event.target.src = 'assets/images/empty-img.svg';
  }
}
